import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import api from '@utils/api';
import { useI18n } from '@/i18n';
import { IconUser, IconFile, IconShield, IconChevron } from '@components/icons';

const EMPLOYER_LABEL = { groundlink_iii: 'Groundlink III', ryanair_dac: 'Ryanair DAC' };

const container = { hidden: {}, show: { transition: { staggerChildren: 0.07, delayChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 14 }, show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] } } };

export default function Home() {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [staff, setStaff] = useState(null);

  const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return t('home.morning');
    if (h < 19) return t('home.afternoon');
    return t('home.evening');
  };
  const TILES = [
    { to: '/profile',   Icon: IconUser,   title: t('home.profileTitle'), desc: t('home.profileDesc') },
    { to: '/documents', Icon: IconFile,   title: t('home.docsTitle'),    desc: t('home.docsDesc') },
    { to: '/gdpr',      Icon: IconShield, title: t('home.gdprTitle'),    desc: t('home.gdprDesc') },
  ];

  useEffect(() => {
    api.get('/staff/me').then(({ data }) => setStaff(data.staff)).catch(() => setStaff(null));
  }, []);

  const firstName = staff?.first_name || '';
  const station   = staff?.base_airport;
  const employer  = staff?.employer;

  return (
    <div className="px-5 md:px-0 pt-6 space-y-6">
      {/* Signature greeting band */}
      <motion.section
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        className="greeting-band"
      >
        <p className="text-sm text-white/70">{greeting()},</p>
        <h1 className="text-2xl font-bold mt-0.5">{firstName || t('home.fallbackName')}</h1>
        <div className="flex flex-wrap items-center gap-2 mt-4">
          {station && <span className={`badge-station badge-station-${station} !bg-white/15 !text-white`}>{station}</span>}
          {employer && <span className="badge-employer !bg-white/10 !text-white !border-white/20">{EMPLOYER_LABEL[employer] || employer}</span>}
        </div>
      </motion.section>

      {/* Quick actions */}
      <motion.div variants={container} initial="hidden" animate="show" className="space-y-3">
        {TILES.map(({ to, Icon, title, desc }) => (
          <motion.button key={to} variants={item} whileTap={{ scale: 0.99 }}
            onClick={() => navigate(to)} className="tile">
            <span className="tile-icon"><Icon size={22} /></span>
            <span className="flex-1 min-w-0">
              <span className="block font-semibold text-glk-dark">{title}</span>
              <span className="block text-sm text-gray-500 mt-0.5">{desc}</span>
            </span>
            <span className="self-center text-gray-300"><IconChevron size={20} /></span>
          </motion.button>
        ))}
      </motion.div>
    </div>
  );
}
